import { RuleType, DataQualityFormData } from "./types"

/**
 * Configuration for each DQDL rule type. Maps rule types to their display labels and required form
 * fields.
 */
export const DQDL_RULES: Record<RuleType, { label: string; fields: string[] }> = {
  IsComplete: { label: "Is Complete", fields: ["column", "where"] },
  IsPrimaryKey: { label: "Is Primary Key", fields: ["columns"] },
  ColumnValues: { label: "Column Values Match", fields: ["column", "pattern"] },
  CustomSql: { label: "Custom SQL", fields: ["sql"] },
  DataFreshness: { label: "Data Freshness", fields: ["column", "days"] },
  ColumnLength: { label: "Column Length", fields: ["column", "min", "max"] },
  // Derived-only (from the Metadata tab's Format): rendered read-only in
  // DerivedRulesSection and never edited, so it advertises no editable fields.
  ColumnDataType: { label: "Column Data Type", fields: ["column"] },
  Completeness: { label: "Completeness Threshold", fields: ["column", "threshold"] },
  DistinctValuesCount: { label: "Distinct Values Count", fields: ["column", "min"] },
}

/**
 * Default values for a new Data Quality Rules form.
 */
export const DEFAULT_FORM_VALUES: DataQualityFormData = {
  fileMatching: { pattern: ".*" },
  preConformance: {
    uploadFormat: { allowZip: true, allowUnzipped: true, requireZip: false },
    zipFile: { nameRegex: "", maxLength: 40, validateStudyId: true },
    fileCount: { min: 1, max: 5 },
    files: [
      {
        name: "",
        nameRegex: "",
        maxLength: 40,
        allowedExtensions: "",
        required: true,
        validateStudyId: false,
      },
    ],
  },
  majorRules: [],
  majorPii: { enabled: false, columns: [] },
  minorRules: [],
  minorPii: { enabled: false, columns: [] },
  table: { name: "", primaryKeyFields: [], skipHeaderRows: 0, scd2: { enabled: true } },
}
